var anObject = require('../internals/an-object');

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/iterator-close.js
// module id = 1042
// module chunks = 0